import './styles.css';
import '../GraphSidePanel.css';

import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { PathLookupResultDetails } from 'components/Graph/GraphSidePanel/PathLookupResultDetails/PathLookupResultDetails';
import type { PathLookupTabId } from 'components/Graph/GraphSidePanelData';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { selectPathLookupResultSeverity } from 'components/Graph/model/selectors/graphMetadata/selectPathLookupResultSeverity';
import { TabLabelWithReportSeverityBadge } from 'components/TabLabelWithBadge/TabLabelWithReportSeverityBadge';
import { TabView } from 'components/Tabs/TabView';
import { useLocale } from 'containers/App/LocaleContext';
import { memo, useMemo } from 'react';
import type { FC } from 'react';
import { PathLookupVisualizationSetup } from '../PathLookupVisualizationSetup/PathLookupVisualizationSetup';
import { GraphPathlookupDataInput } from './GraphPathlookupDataInput';
import { usePathLookupDataInput } from './usePathLookupDataInput';

const BareGraphPathlookup: FC = () => {
  const msg = useLocale();

  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    tabId: prop('sidePanel', 'pathLookupTabId'),
    resultSeverity: selectPathLookupResultSeverity,
  });

  const pathLookupDataInput = usePathLookupDataInput();

  const tabs = useMemo(
    () =>
      [
        {
          key: 'dataInput',
          label: msg.canvasGraph.graphSidePanel.pathlookup.tabs.dataInput,

          render: () => (
            <GraphPathlookupDataInput
              pathLookupDataInputHook={pathLookupDataInput}
            />
          ),
        },
        {
          key: 'visualizationSetup',
          label:
            msg.canvasGraph.graphSidePanel.pathlookup.tabs.visualizationSetup,

          render: () => (
            <PathLookupVisualizationSetup
              pathLookupDataInputHook={pathLookupDataInput}
            />
          ),
        },
        {
          key: 'resultDetails',
          label: (
            <TabLabelWithReportSeverityBadge
              badge={ctxProps.resultSeverity ?? undefined}
              text={
                msg.canvasGraph.graphSidePanel.pathlookup.tabs.resultDetails
              }
            />
          ),

          render: () => <PathLookupResultDetails />,
        },
      ] as const,
    [ctxProps.resultSeverity, pathLookupDataInput, msg],
  );

  return (
    <div className='graph-side-panel-tabbed-content flex flex-1 flex-col'>
      <TabView<PathLookupTabId>
        activeTab={ctxProps.tabId}
        onChangeTab={(pathLookupTabId) => {
          ctxProps.dispatch(showSidePanel, { pathLookupTabId });
        }}
        stretch
        tabs={tabs}
        className='graph-side-panel-tabs-cards pb-lgu-3'
        variant='legacy'
      />
    </div>
  );
};

export const GraphPathlookup = memo(BareGraphPathlookup);
